import { type ComponentProps, useEffect } from 'react';

import { setHeaderConfig } from '@/store/app.slice';
import { useAppDispatch } from '@/store/store';

import ErrorTemplate from './error-template';

type IProps = Omit<ComponentProps<typeof ErrorTemplate>, 'type'>;

const NotFound: React.FC<IProps> = ({ ...props }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderConfig({ helmetTitle: '404' }));
    return () => {
      dispatch(setHeaderConfig({}));
    };
  }, []);

  return <ErrorTemplate type="404" {...props} />;
};

export default NotFound;
